import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavGroup } from "./types";
import { useState } from "react";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { SidebarNavItem } from "./SidebarNavItem";
import { cn } from "~/lib/utils";
import { areNavItemsActive } from "./isNavItemActive";
import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";

// // // //

export function SidebarNavGroup(props: {
    group: NavGroup;
    activePathname: string;
    collapsed: boolean;
    groupIndex: number;
}) {
    const { group, activePathname, collapsed, groupIndex } = props;
    const { items, expandable, defaultExpandedState = true } = group;

    const hasActiveChild = areNavItemsActive({
        items: group.items,
        pathname: activePathname,
    });
    const [expanded, setExpanded] = useState(
        hasActiveChild ? true : defaultExpandedState,
    );
    const hasLabel = group.label !== undefined;

    return (
        <FeatureFlag feature={group.featureFlag}>
            <div
                className={cn({ "mb-4": hasLabel && !collapsed })}
                id={group.key}
            >
                {!collapsed && hasLabel && (
                    <div className="flex items-center justify-between px-3">
                        <p className="label-03 text-muted-foreground">
                            {group.label}
                        </p>
                        {expandable && (
                            <button
                                className="ml-2"
                                onClick={() => {
                                    setExpanded(!expanded);
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={
                                        expanded ? faChevronDown : faChevronUp
                                    }
                                    className="h-[16px] w-[16px] text-secondary-foreground"
                                />
                            </button>
                        )}
                    </div>
                )}
                {collapsed && groupIndex > 0 && <hr className="mb-0" />}
                <div
                    className={cn("transition-all overflow-hidden", {
                        "h-0!": !expanded && !collapsed,
                        // "h-auto": expanded || collapsed,
                        "h-full": expanded || collapsed,
                    })}
                >
                    {items.map((item) => (
                        <SidebarNavItem
                            key={item.key}
                            item={item}
                            activePathname={activePathname}
                            collapsed={collapsed}
                            parentGroup={group}
                        />
                    ))}
                </div>
            </div>
        </FeatureFlag>
    );
}
